"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AssetsModalCarousel = AssetsModalCarousel;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const elements_1 = require("@src/components/elements");
const get_cdn_image_url_1 = require("@src/shared/get-cdn-image-url");
const get_asset_image_source_1 = require("@src/shared/get-asset-image-source");
const icons_1 = require("@ant-design/icons");
const use_keyboard_controlls_1 = require("@src/hooks/use-keyboard-controlls");
const mux_video_react_1 = __importDefault(require("@mux/mux-video-react"));
const types_1 = require("@src/types");
const AssetsModalCarousel_style_1 = require("./AssetsModalCarousel.style");
function getAssetImgUrl(asset) {
    return (0, get_cdn_image_url_1.getCdnImageUrl)({
        file: (0, get_asset_image_source_1.getAssetImageSource)(asset),
        shouldIncludeEnvironmentPart: false,
        addWatermarkedLogo: true,
    });
}
function CarouselPrevArrow({ onClick }) {
    return ((0, jsx_runtime_1.jsx)(AssetsModalCarousel_style_1.CarouselArrowContainer, { position: "left", onClick: onClick, children: (0, jsx_runtime_1.jsx)(icons_1.LeftOutlined, {}) }));
}
function CarouselNextArrow({ onClick }) {
    return ((0, jsx_runtime_1.jsx)(AssetsModalCarousel_style_1.CarouselArrowContainer, { position: "right", onClick: onClick, children: (0, jsx_runtime_1.jsx)(icons_1.RightOutlined, {}) }));
}
function VideoAsset({ asset, pauseTriggerSymbol }) {
    const videoRef = react_1.default.useRef(null);
    react_1.default.useEffect(() => {
        videoRef.current.pause();
    }, [pauseTriggerSymbol]);
    return (
    // @ts-ignore
    (0, jsx_runtime_1.jsx)(mux_video_react_1.default, { ref: videoRef, style: { maxWidth: '95%', maxHeight: '95%' }, playbackId: asset.muxPublicPlaybackId, metadata: {
            video_id: String(asset.id),
            video_title: asset.filename,
        }, 
        // @ts-ignore
        autoPlay: true, envKey: process.env.MUX_VIDEO_TRACK_KEY, 
        // @ts-ignore
        streamType: "on-demand", disablePictureInPicture: true, controls: true, loop: false }));
}
function AssetsModalCarousel({ assets, initialAssetId, closeModal }) {
    const carouselRef = react_1.default.useRef(null);
    const [currentAssetIndex, setCurrentAssetIndex] = react_1.default.useState(null);
    const [triggerSymbol, setTriggerSymbol] = react_1.default.useState(Symbol('triggerSymbol'));
    react_1.default.useEffect(() => {
        const initialAssetIndex = assets.findIndex(ass => ass.id === initialAssetId);
        if (initialAssetIndex > -1) {
            setCurrentAssetIndex(initialAssetIndex);
        }
    }, [initialAssetId]);
    react_1.default.useEffect(() => {
        if (currentAssetIndex !== null) {
            carouselRef.current.goTo(currentAssetIndex);
            pauseAllVideos();
        }
    }, [currentAssetIndex]);
    const pauseAllVideos = () => {
        setTriggerSymbol(Symbol('triggerSymbol'));
    };
    const handleAfterChange = (newAssetIndex) => {
        if (currentAssetIndex !== newAssetIndex) {
            setCurrentAssetIndex(newAssetIndex);
        }
    };
    const handleImageClick = (e) => {
        e.stopPropagation();
    };
    (0, use_keyboard_controlls_1.useKeyboardControlls)({
        onEscape: closeModal,
        onArrowLeft: () => carouselRef.current.prev(),
        onArrowRight: () => carouselRef.current.next(),
    });
    return ((0, jsx_runtime_1.jsx)(elements_1.Carousel, { ref: carouselRef, dots: false, arrows: true, afterChange: handleAfterChange, prevArrow: (0, jsx_runtime_1.jsx)(CarouselPrevArrow, {}), nextArrow: (0, jsx_runtime_1.jsx)(CarouselNextArrow, {}), children: assets.map(asset => ((0, jsx_runtime_1.jsxs)(AssetsModalCarousel_style_1.AssetContainer, { children: [asset.type === types_1.AssetType.IMAGE && ((0, jsx_runtime_1.jsx)(AssetsModalCarousel_style_1.AssetImg, { src: getAssetImgUrl(asset), onClick: handleImageClick })), asset.type === types_1.AssetType.VIDEO && (0, jsx_runtime_1.jsx)(VideoAsset, { asset: asset, pauseTriggerSymbol: triggerSymbol })] }, asset.id))) }));
}
